/** @format */

import { Addon, CartAddOn } from '../cart-checkout/addons.interface';
import { SelectedAddOn, Warranty } from '../warranty.interface';

import { IPersonalizedAttributes } from './personalized-attributes.interface';
import { IProcureMethod } from './procure-method.interface';

export interface ICartItem {
  addons?: Addon[] | CartAddOn;
  attributes?: { [key: string]: string | number };
  availability?: number;
  availableWarranties?: Warranty[];
  bopisable?: boolean;
  boplable?: boolean;
  description?: string;
  ecode?: string;
  external_key?: string;
  images?: string[];
  is_save_for_later?: boolean;
  link?: string;
  list_price?: string;
  my_customizer_doc?: string;
  name?: string;
  parent_external_key?: string;
  personalized?: IPersonalizedAttributes;
  pre_sale?: boolean;
  price?: string;
  price_strikethrough?: string;
  price_total?: string;
  procure?: IProcureMethod;
  qty?: number;
  samedayable?: boolean;
  shippable?: boolean;
  sku?: string;
  sku_base?: string;
  unit_price?: string;
  warranty_eligible?: boolean;
  isCalia?: boolean;
  isScoreCardPlus?: boolean;
}

export interface CartWarrantyData {
  isWarrantyEligible: boolean;
  isWarrantyAdded: boolean;
  warrantyOptions: Warranty[];
  selectedAddOn: SelectedAddOn[];
  isMobile: boolean;
  loadingData: boolean;
  warrantySelectionFailed: boolean;
}
